import { NgModule } from '@angular/core';

// Parité V1 : ClickOutsideModule venait de 'ng-click-outside' — remplacé par le module vendored local (même API).
import { ClickOutsideModule } from '@shared/vendored/click-outside';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PasswordModule } from 'primeng/password';
// Parité V1 : CaptchaModule ('primeng/captcha') n'existe plus en PrimeNG 21 et aucun template
// du module n'utilise <p-captcha> — le flux reCAPTCHA passe par RecaptchaService (script global
// reCAPTCHA v3 dans index.html). Import supprimé sans impact fonctionnel.
import { RecaptchaService } from '../../../services/security/recaptcha-service';
// Parité V1 : imports groupés 'primeng/primeng' interdits en PrimeNG 21 → imports individuels.
import { CheckboxModule } from 'primeng/checkbox';
// Parité V1 : DropdownModule → SelectModule (renommage PrimeNG 21). Aucun template du module
// n'utilise <p-dropdown>/<p-select>, import conservé pour parité avec le module V1.
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TwoFactorSendCodeComponent } from './components/twofactor/send-code/send-code.component';
import { TwoFactorVerifyCodeComponent } from './components/twofactor/verify-code/verify-code.component';
// Parité V1 : ShowHidePasswordModule / ShowHideService ('ngx-show-hide-password') supprimés —
// 0 usage vérifié dans les templates et aucun composant n'injecte ShowHideService.
import { NewPasswordComponent } from './components/newpassword/newpassword.component';
import { SendTokenResetPasswordComponent } from './components/sendtokennewpassword/send-token-possword.component';
import { ConfirmAccountComponent } from './components/confirm-account/confirm-account.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { CreateAccountSuccessComponent } from './components/create-account-success/create-account-success.component';
import { LoginComponent } from './components/login/login.component';
import { LoginAsExternalComponent } from './components/login-as-external/login-as-external.component';
// Parité V1 : angular-code-input v2 expose toujours CodeInputModule (NgModule) — import inchangé.
import { CodeInputModule } from 'angular-code-input';
// Parité V1 : CircleTimerModule venait de '@flxng/circle-timer' — remplacé par le module vendored
// local (même API : flx-circle-timer, duration/color, onComplete, start/init/isTicking).
import { CircleTimerModule } from '@shared/vendored/circle-timer';

@NgModule({
  declarations: [
    LoginComponent,
    LoginAsExternalComponent,
    TwoFactorSendCodeComponent,
    TwoFactorVerifyCodeComponent,
    SendTokenResetPasswordComponent,
    NewPasswordComponent,
    ConfirmAccountComponent,
    CreateAccountComponent,
    CreateAccountSuccessComponent
  ],
  // Parité V1 : BrowserModule retiré (réservé au module racine en Angular 21) — CommonModule suffit ici.
  imports: [
    CommonModule,
    RouterModule,
    ClickOutsideModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    PasswordModule,
    CheckboxModule,
    SelectModule,
    RadioButtonModule,
    CodeInputModule,
    CircleTimerModule
  ],
  providers: [
    RecaptchaService
  ],
  exports: [LoginComponent, TwoFactorSendCodeComponent, TwoFactorVerifyCodeComponent]
  // Parité V1 : entryComponents supprimés (obsolètes avec Ivy).
})
export class AuthAccountModule { }
